export const itemsTypes = {
  SET_ITEMS: 'SET_ITEMS',
};
